<p>Navigate to incident</p>
@if (!isLoading){
    <app-map-navigation [destination]="destinationCoords"></app-map-navigation>
}
